import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  sectionHeader: {
    padding: theme.spacing(1),
    backgroundColor: 'var(--color-primary-500)',
    color: 'var(--color-primary-050)',
    borderRadius: 'var(--border-radius-md)',
    marginBottom: '2px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    backgroundColor: 'var(--color-neutral-200)'
  },
  label: {
    display: 'inline-flex',
    backgroundColor: 'var(--color-primary-500)',
    color: 'var(--color-primary-050)',
    padding: '2px 6px',
    borderRadius: 'var(--border-radius-sm)',
    marginLeft: '4px',
    fontSize: '.8em'
  },
  collapseButton: {
    '& svg': {
      transition: 'all 0.3s',
      rotate: '180deg'
    }
  },
  collapseButtonActive: {
    '& svg': {
      transition: 'all 0.3s',
      rotate: '0deg'
    }
  },
  collapsedTable: {
    height: 0,
    overflow: 'hidden'
  }
}))
export default useStyles
